<template>
  <span
    v-if="date"
    class="vue-moments-ago"
  >{{ prefix }} {{ humanFormatted }} {{ suffix }}</span>
</template>

<script>

import moment from 'moment-timezone';

export default {
  props: {
    prefix: {
      type: String,
      default: 'posted',
    },
    suffix: {
      type: String,
      default: 'ago',
    },
    date: {
      required: true,
    },
    lang: {
      type: String,
      default: 'en',
    },
  },
  data() {
    return {
      language: {
        en: {
          few: 'a few',
          postfix: 's',
        },
      },
      epochs: {
        en: ['year', 'month', 'day', 'hour', 'minute'],
      },
      year: 31536000,
      month: 2592000,
      day: 86400,
      hour: 3600,
      minute: 60,
      humanReadable: '',
      humanDifference: 0,
      humanWord: 'moment',
    };
  },
  computed: {
    humanFormatted() {
      if (this.humanDifference === 0) {
        return (
          `${this.language[this.lang].few
          } ${
            this.humanWord
          }${this.language[this.lang].postfix}`
        );
      } if (this.humanDifference > 1) {
        return (
          `${this.humanDifference
          } ${
            this.humanWord
          }${this.language[this.lang].postfix}`
        );
      } if (this.humanDifference < 0) {
        return (
          `${this.humanDifference
          } ${
            this.humanWord
          }${this.language[this.lang].postfix}`
        );
      }

      return `${this.humanDifference} ${this.humanWord}`;
    },
  },
  created() {
    this.moment = moment;
  },
  mounted() {
    this.$nextTick(() => {
      this.getSeconds(this.date);
    });
  },
  methods: {
    getSeconds(time) {
      const seconds = Math.abs(moment().diff(moment(time), 'seconds'));
      this.humanReadable = this.getDuration(seconds);
      if (this.humanReadable) {
        this.humanDifference = this.humanReadable.interval;
        this.humanWord = this.humanReadable.humanEpoch;
      }
    },
    getDuration(seconds) {
      let epoch; let
        interval;
      let humanEpoch;
      for (let i = 0; i < this.epochs[this.lang].length; i++) {
        epoch = this.epochs.en[i];
        humanEpoch = this.epochs[this.lang][i];
        interval = Math.floor(seconds / this[epoch]);
        if (interval >= 1) {
          return { interval, humanEpoch };
        }
      }
    },
  },
};
</script>

<style scoped>
</style>
